import { Card, CardHeader, CardBody } from 'react-bootstrap';

const CustomerReview = () => (
  <Card className="bg-transparent">
    <CardHeader className="border-bottom bg-transparent px-0 pt-0">
      <h3 className="card-title mb-0">Guest reviews</h3>
    </CardHeader>
    <CardBody className="pt-4 p-0">
      <p className="text-muted mb-0">Guest reviews will appear here once they are published for this hotel.</p>
    </CardBody>
  </Card>
);

export default CustomerReview;
